import {addEvent} from '../add-event'

export function showFilterEvent(): boolean {
    return addEvent('reportsPageShowFilter', {})
}
